import { CircularProgress, Dialog, DialogActions, DialogTitle, Divider } from '@mui/material';
import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Button } from '../new/Button';
import { Typography } from '../new/Typography';

interface QDirectRecoveryDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading: boolean;
  error: string | null;
}

const QDirectRecoveryDialog: React.FC<QDirectRecoveryDialogProps> = ({ open, onClose, onConfirm, loading, error }) => {
  return (
    <Dialog
      open={open}
      maxWidth="lg"
      onClose={onClose}
      sx={{
        '& .MuiDialog-container': {
          alignItems: 'center',
          justifyContent: 'center',
        },
        '& .MuiPaper-root': {
          background: '#ffffff',
          minWidth: '37.5rem',
          margin: 'auto',
        },
      }}
    >
      <DialogTitle>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            gap: '2rem',
          }}
        >
          <Typography sx={{ color: '#140838', fontSize: '1.125rem', fontWeight: 500 }}>
            Are you sure you want to initiate the QDirect Recovery Process?
          </Typography>
          <CloseIcon sx={{ cursor: 'pointer', marginTop: '0.25rem' }} onClick={onClose} />
        </div>
      </DialogTitle>
      <Divider sx={{ color: '#D6D6D6' }} />
      {error && <Typography sx={{ color: '#d32f2f', padding: '0 1.5rem' }}>{error}</Typography>}
      <DialogActions sx={{ padding: '1rem 1.5rem', justifyContent: 'flex-end', gap: '1rem' }}>
        <Button
          type="outline"
          sx={{ whiteSpace: 'nowrap', width: 'auto', padding: '0.625rem 1.5rem' }}
          onClick={onClose}
          disabled={loading}
        >
          No
        </Button>
        <Button
          type="primary"
          sx={{ whiteSpace: 'nowrap', width: 'auto', padding: '0.625rem 1.5rem' }}
          onClick={onConfirm}
          disabled={loading}
        >
          {loading ? <CircularProgress size={20} color="inherit" /> : 'Yes'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default QDirectRecoveryDialog;
